export const statusList = [
  { id: "1", name: "可使用" },
  { id: "2", name: "发起还价" },
  { id: "3", name: "已补偿给卖家" },
  { id: "4", name: "申请退款" },
  { id: "5", name: "已原路退款" },
  { id: "6", name: "系统扣除" },
  { id: "7", name: "退款审核不通过" },
];

export const orderColumns = [
  {
    title: "UID",
    key: "uid",
    align: "center",
  },
  {
    title: "保证金订单号",
    key: "order_num",
    align: "center",
  },
  {
    title: "用户账号",
    key: "account",
    align: "center",
  },
  {
    title: "支付时间",
    key: "pay_time",
    align: "center",
  },
  {
    title: "充值方式",
    key: "pay_type_txt",
    align: "center",
  },
  {
    title: "现在状态",
    key: "status_txt",
    align: "center",
  },
  {
    title: "退款时间",
    key: "refund_time",
    align: "center",
  },
  {
    title: "补偿时间",
    key: "compensate_time",
    align: "center",
  },
  {
    title: "补偿金额（元）",
    key: "compensate_amount",
    align: "center",
  },
  {
    title: "操作",
    slot: "action",
    align: "center",
    width: 350,
  },
];
export const LogColumns = [
  {
    title: "用户操作日志",
    key: "status_txt",
    align: "center",
  },
  {
    title: "关联还价订单号",
    key: "bargain_id",
    align: "center",

    render: (h, params) => {
      return h("div", [
        h("span", {}, params.row.bargain_id ? params.row.bargain_id : ""),
      ]);
    },
  },
  {
    title: "操作时间",
    key: "create_time",
    align: "center",
  },
];

export const PayTimes = [
  { key: "pay_time", name: "支付时间" },
  { key: "compensate_time", name: "补偿时间" },
  { key: "refund_time", name: "退款时间" },
];
